<div class="payment grow--min ie--use-100vh grey-25-bg">
  <fcom-loader aria-live="polite" [paragraph]="'payment.initializing'" />
</div>
<link
  rel="dns-prefetch"
  [attr.data-payment-flow]="paymentFlow"
  [attr.data-service-name]="serviceName"
  [href]="checkoutUrl | finSafe: 'resource'"
/>
